import React from 'react'

const AboutTabsComp = () => {
  return (
    <section id="c-sectionAboutTabs" className="c-sectionWrapper">
    <div className="container">
        <div className="c-aboutTabUlWrapper">
            <ul className="nav nav-tabs" id="c-aboutTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <a className="nav-link active" 
                        id="abt-vision-tab" 						
                        href="#abt-vision" data-toggle="tab"  role="tab" 
                        aria-controls="abt-vision" aria-selected="true">Our Vision</a>
                </li>
                <li className="nav-item" role="presentation">
                    <a className="nav-link" 
                        id="abt-mission-tab" 
                        href="#abt-mission" data-toggle="tab" role="tab" 
                        aria-controls="abt-mission" aria-selected="false">Our Mission</a>
                </li>
                <li className="nav-item" role="presentation">
                    <a className="nav-link" 
                        id="abt-values-tab" 
                        href="#abt-values" data-toggle="tab" role="tab" 
                        aria-controls="abt-values" aria-selected="false">Values</a>
                </li>

                <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle active" data-toggle="dropdown" href="#" role="button" aria-expanded="false">Our Vision</a>
                    <div className="dropdown-menu">
                        <a className="dropdown-item active" href="#abt-vision" data-toggle="tab"  role="tab" 
                            aria-controls="abt-vision">Our Vision</a>
                        <a className="dropdown-item" href="#abt-mission" data-toggle="tab" role="tab" 
                            aria-controls="abt-mission">Our Mission</a>
                        <a className="dropdown-item" href="#abt-values" data-toggle="tab" role="tab" 
                            aria-controls="abt-values">Values</a>					
                    </div>
                </li>
            </ul>
        </div>
        <div className="tab-content" id="c-aboutTabContent">
            <div className="tab-pane fade show active" id="abt-vision" role="tabpanel" 
                aria-labelledby="abt-vision-tab">
                <div className="row">
                    <div className="col-lg-4 col-md-4">
                        <img src="./images/aboutus/vision.png" className="img-fluid c-abtVisionContentImg" alt="" title="" />
                    </div>
                    <div className="col-lg-8 col-md-8">
                        <h5 className="c-aboutTabMainTitle">Our Vision:</h5>
                        <p>
                            FINAYO aspires to carve a distinctive niche in the EV lending space with its disruptive, automated platforms.
                            <br/><br/>
                            The company aims to complement the initiative of the Government of India to cut carbon emissions and drive the adoption of EVs with real time, seamless lending platforms. 
                            <br/><br/>
                            Building bridges to enable credit innovation and produce a financially inclusive india.
                        </p>
                    </div>					
                </div>
            </div>
            <div className="tab-pane fade" id="abt-mission" role="tabpanel" 
                aria-labelledby="abt-mission-tab">
                <div className="row">
                    <div className="col-lg-4 col-md-4">
                        <img src="./images/aboutus/mission.png" className="img-fluid c-abtVisionContentImg" alt="" title="" />
                    </div>
                    <div className="col-lg-8 col-md-8">
                        <h5 className="c-aboutTabMainTitle">Our Mission:</h5>
                        <p>
                            With a firm commitment to offer a win-win proposition for OEMs, lenders and consumers, FINAYO will continue to set new benchmarks in the automated lending space.
                            <br/><br/>
                            We will also replicate our success story in India in other key markets across the globe.
                            <br/><br/>
                            Our trend setting platform enables the OEMs in the EV space and lenders to enhance their customer base and tap on new revenue opportunities swiftly.

                        </p>
                    </div>					
                </div>
            </div>
            <div className="tab-pane fade" id="abt-values" role="tabpanel" 
                aria-labelledby="abt-values-tab">
                <div className="row">
                    <div className="col-lg-4 col-md-4">
                        <img src="./images/aboutus/value.png" className="img-fluid c-abtVisionContentImg" alt="" title="" />
                    </div>
                    <div className="col-lg-8 col-md-8">
                        <h5 className="c-aboutTabMainTitle">Values:</h5>
                        <p>
                            <span className="c-heading38Bold" style={{color: "orange "}}>Innovation:</span> 
                            we believe in continous innovation and focus on creating new products and services that can elevate our partners experiences and businesses.
                            <br/><br/>
                            <span className="c-heading38Bold" style={{color: "orange "}}>Integrity:</span>
                            We believe that trust has to be earned and we display our integrity through transparency in all our undertakings and financial disclosures.
                             <br/><br/>
                             <span className="c-heading38Bold" style={{color: "orange "}}>Excellence:</span>
                             Whatever we do, we strive to do it well! we focus our efforts around the specific needs of the client and hold ourselves personally accountable for delivering results.
                             <br/><br/>
                             <span className="c-heading38Bold" style={{color: "orange "}}>Ethics:</span>
                             A strict code of ethics governs our relationships with clients as well as our stakeholders
                        </p>
                    </div>					
                </div>
            </div>
        </div>
    </div>
</section>
  )
}

export default AboutTabsComp